export default {
    namespaced: true,
    state: () => ({
      highlight: {
        line1: false,
        line2: false,
        postalCode: false,
        inputChanged: false,
        csgSuggestions: false,
        message: '',
        message2: '',
        message3: '',
        message4: '',
        message5: '',
        message6: '',
        recaptcha: false
      }
    }),
    mutations: {
      RESET_HIGHLIGHTS(state) {
        state.highlight = {
          line1: false,
          line2: false,
          postalCode: false,
          inputChanged: false,
          csgSuggestions: false,
          message: '',
          message2: '',
          message3: '',
          message4: '',
          message5: '',
          message6: '',
          recaptcha: false
        };
      },
      SET_HIGHLIGHT(state, payload) {
        state.highlight = {...state.highlight, ...payload};
      }
    },
    actions: {
      resetHighlights({ commit }) {
        commit('RESET_HIGHLIGHTS');
      }
    }
  };